<div class="list-for-wizzard-products">
    <div class="list-for-wizzard-products__inner row">

        <ng-container *ngIf="loading">
            <div class="list-for-wizzard-products__item col" *ngFor="let item of emptyPlaceholders">
                <shared-tile-for-wizzard [loading]="true"></shared-tile-for-wizzard>
            </div>
        </ng-container>

        <ng-container *ngIf="!loading">
            <ng-container *ngFor="let product of menuFlowProducts | limit:limit; trackBy: menuFlowProductsTrackBy">
                <div class="list-for-wizzard-products__item col">
                    <shared-tile-for-wizzard [wizzardProduct]="product"
                        [page]="product['_OriginalPage'] || menuFlowPage">
                    </shared-tile-for-wizzard>
                </div>
            </ng-container>
        </ng-container>

    </div>
</div>